import {sellerConstants } from '../../_constants/seller.constants';

const initialState = { loading : true, admins: '', error: false};

export function sellerAdmins(state = initialState, action) {
    switch (action.type) {
      case sellerConstants.REQUEST_SELLER_ADMIN:
        return {
          loading: true,
          admins: '',
          error: false
        };
      case sellerConstants.RECEIVE_SELLER_ADMIN:
        return {
          loading: false,
          admins: action.sellerAdmins.data.seller_admin_list,
          error: false
        };
      case sellerConstants.SELLER_ADMIN_LIST_ERROR:
        return { 
          loading: false,
          admins: '',
          error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/sellers/sellerAdmin.reducer.js